exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".statistic-box[data-v-393fa154]{border-radius:5px;margin-top:20px;background-color:#fff;border:1px solid #e6ebf5}.statistic-box[data-v-393fa154]  .el-card__body{padding:10px}", ""]);

// exports
